import { render, staticRenderFns } from "./BadGateway.vue?vue&type=template&id=0801fadd&scoped=true"
import script from "./BadGateway.vue?vue&type=script&lang=js"
export * from "./BadGateway.vue?vue&type=script&lang=js"
import style0 from "./BadGateway.vue?vue&type=style&index=0&id=0801fadd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9b90bd239842d9ab132761d251f24808/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0801fadd",
  null
  
)

export default component.exports